// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');

// @ commons
const { formatText } = require('core/i18n').i18n;
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @ actions
const cardPeriodicLoadsActions = require('actions/cardPeriodicLoads');

// @ components
const CardHeaderDetails = require('components/cards/cardHeaderDetails/cardHeaderDetails');
const CardDetailsSidebar = require('components/cards/cardDetailsSidebar/cardDetailsSidebar');
const TutorialLauncher = require('components/tutorial/tutorialLauncher');
const DeletePeriodicLoad = require('./deletePeriodicLoad');

// @ utilities
const DeletePeriodicLoadSuccessStep = require('./deletePeriodicLoadSuccessScreen');
const DeletePeriodicLoadErrorStep = require('./deletePeriodicLoadErrorScreen');
const { isEmpty } = require('lodash');

// @ constants
const { GRAPHIC_TUTOR_TYPE_4 } = require('constants/index');

class DeletePeriodicLoadView extends React.Component {
    componentDidMount() {
        const {
            cardPeriodicLoads,
            deletePeriodicLoadRequest,
            getPeriodicLoadsList,
            immCards,
            match: { params: { cardId } },
        } = this.props;
        if (cardPeriodicLoads.get('byOrder').size === 0 || isEmpty(cardPeriodicLoads.get('byId'))) {
            const immCard = immCards.getIn(['byId', cardId]);
            getPeriodicLoadsList(immCard);
        }
        deletePeriodicLoadRequest();
    }

    render() {
        const {
            cardPeriodicLoads,
            deletePreiodicLoad,
            immAccounts,
            immCards,
            match: { params: { cardId, scheduleTransferId } },
        } = this.props;
        const immCard = immCards.getIn(['byId', cardId]);
        const periodicLoadData = cardPeriodicLoads.getIn(['byId', scheduleTransferId]);
        let block;
        if (immCard) {
            const titleEditable = formatText('deletePeriodicLoadsSuccess-title');
            const type = immCard.get('type');
            const subtitleLeft = formatText(`cards-${type}`);
            const subtitleRight = immCard ? immCard.getIn(['alias', 'current']).toUpperCase() : '';
            const mappingBreadcrumb = [
                {
                    text: formatText('breadcrumb-cards'),
                    url: '/myprofile/cards'
                },
                {
                    text: immCard ? immCard.get('alias').get('current') : '',
                    url: `/myprofile/cards/${cardId}/movements`
                },
                {
                    text: formatText('breadcrumb-cardPeriodicLoads'),
                    url: `/myprofile/cards/${cardId}/periodic-loads`
                },
                {
                    text: formatText('breadcrumb-deletePeriodicLoadsView')
                }
            ];
            const tutorial = (
                <TutorialLauncher
                    type={GRAPHIC_TUTOR_TYPE_4}
                    title={formatText('deletePeriodicLoadsSuccess-title')}
                />
            );
            if (cardPeriodicLoads.get('getLoadsListFetch')) {
                block = <LoadingSection />;
            } else if (cardPeriodicLoads.get('deleteSuccessful')) {
                block = (
                    <DeletePeriodicLoadSuccessStep
                        immCard={immCard}
                        periodicLoadData={periodicLoadData}
                        immAccounts={immAccounts}
                    />
                );
            } else if (!!cardPeriodicLoads.get('errorMessage')) {
                block = (
                    <DeletePeriodicLoadErrorStep
                        immCard={immCard}
                    />
                );
            } else if (cardPeriodicLoads.get('byOrder').size > 0 && !isEmpty(cardPeriodicLoads.get('byId'))) {
                block = (
                    <div className="col-md-12">
                        <div className="col-md-8">
                            <DeletePeriodicLoad
                                periodicLoadData={periodicLoadData}
                                immAccounts={immAccounts}
                                handleDeletePreiodicLoad={deletePreiodicLoad}
                                cardId={cardId}
                            />
                        </div>
                        <div className="col-md-4">
                            <CardDetailsSidebar immCard={immCard} />
                        </div>
                    </div>
                );
            }

            return (
                <div>
                    <div className="container-fluid card-movements--header-identifier">
                        <div className="row">
                            <OKCover size="medium" section="cards" customClass="col-xs-12">
                                <OKHeaderSubPage
                                    breadcrumbConfig={mappingBreadcrumb}
                                    subtitleLeft={subtitleLeft}
                                    subtitleRight={subtitleRight}
                                    finalTitle={titleEditable}
                                    tutorial={tutorial}
                                    hasTitle={__CONTACT_CENTER__ ? true : undefined}
                                >
                                    <CardHeaderDetails
                                        immCard={immCard}
                                        rightSpace={true}
                                    />
                                </OKHeaderSubPage>
                            </OKCover>
                        </div>
                    </div>
                    <div className="grid-view__body">
                        <div className="container-fluid">
                            <div className="row grid-view--content-position-negative">
                                {block}
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
    }
}

DeletePeriodicLoadView.propTypes = {
    cardPeriodicLoads: PropTypes.object.isRequired,
    deletePreiodicLoad: PropTypes.func.isRequired,
    deletePeriodicLoadRequest: PropTypes.func.isRequired,
    getPeriodicLoadsList: PropTypes.func.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immCards: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
};

module.exports.constructor = DeletePeriodicLoadView;
module.exports.DeletePeriodicLoadView = connect(
    state => ({
        cardPeriodicLoads: state.cardPeriodicLoads,
        immAccounts: state.accounts,
        immCards: state.cards
    }),
    {
        deletePreiodicLoad: cardPeriodicLoadsActions.deletePreiodicLoad,
        deletePeriodicLoadRequest: cardPeriodicLoadsActions.deletePeriodicLoadRequest,
        getPeriodicLoadsList: cardPeriodicLoadsActions.getPeriodicLoadsList
    }
)(DeletePeriodicLoadView);
